export default __webpack_public_path__ + "static/media/DSC_5732.9cf34422.jpg";